var scope_0 = require('/builds/underwriters-laboratories/cyd-gatsby/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/991ade6f2d6059c15b59d729b48e9db4.js').default;
var scope_1 = require('/builds/underwriters-laboratories/cyd-gatsby/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    